var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"label":"Händelserubrik","hint":"Obligatorisk","persistent-hint":"","outlined":"","disabled":_vm.disabled,"rules":[_vm.required]},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}})
}
var staticRenderFns = []

export { render, staticRenderFns }